import React, {
  useEffect,
  useState,
} from 'react';

import axios from 'axios';

import {
  Link,
  useParams,
} from 'react-router-dom';

import './PartnershipEnquiryDetailPage.css';

/* global process */

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL;

const ENQUIRIES_URL =
  `${API_BASE_URL}/api/v1/admin/partnership_enquiries`;

const CSRF_URL =
  `${API_BASE_URL}/api/v1/admin/csrf`;

const STATUSES = [
  ['new', 'New'],
  ['reviewed', 'Reviewed'],
  ['contacted', 'Contacted'],
  ['closed', 'Closed'],
];

const PartnershipEnquiryDetailPage = () => {
  const { id } =
    useParams();

  const [
    enquiry,
    setEnquiry,
  ] = useState(null);

  const [
    status,
    setStatus,
  ] = useState('loading');

  const [
    message,
    setMessage,
  ] = useState('');

  const [
    error,
    setError,
  ] = useState('');


  useEffect(() => {
    const loadEnquiry =
      async () => {
        try {
          const response =
            await axios.get(
              `${ENQUIRIES_URL}/${id}`,
              {
                withCredentials: true,
              }
            );

          setEnquiry(
            response.data
          );

          setStatus(
            'ready'
          );
        } catch (requestError) {
          setError(
            requestError.response?.data?.error ||
            requestError.message ||
            'Unable to load enquiry.'
          );

          setStatus(
            'failed'
          );
        }
      };

    loadEnquiry();
  }, [id]);


  const updateStatus =
    async (newStatus) => {
      try {
        setMessage('');
        setError('');

        /*
         * Fetch a fresh CSRF token before
         * the authenticated write request.
         */
        const csrfResponse =
          await axios.get(
            CSRF_URL,
            {
              withCredentials: true,
            }
          );

        const csrfToken =
          csrfResponse.data.csrf_token;

        /*
         * Send the PATCH explicitly with
         * credentials and CSRF protection.
         */
        const response =
          await axios.patch(
            `${ENQUIRIES_URL}/${id}`,
            {
              partnership_enquiry: {
                status: newStatus,
              },
            },
            {
              withCredentials: true,

              headers: {
                'X-CSRF-Token':
                  csrfToken,

                'Content-Type':
                  'application/json',
              },
            }
          );

        setEnquiry(
          response.data
        );

        setMessage(
          'Enquiry status updated.'
        );
      } catch (requestError) {
        console.error(
          'ACE enquiry update error:',
          requestError
        );

        setError(
          requestError.response?.data?.error ||
          requestError.message ||
          'Unable to update status.'
        );
      }
    };


  if (
    status === 'loading' ||
    !enquiry
  ) {
    return (
      <main className="admin-page">
        <p>
          Loading partnership enquiry...
        </p>
      </main>
    );
  }


  return (
    <main className="admin-page">
      <header className="admin-page-header">
        <div>
          <p className="admin-eyebrow">
            Partnership Enquiry
          </p>

          <h1>
            {enquiry.subject}
          </h1>

          <p>
            Submitted by {enquiry.name}
            {' · '}
            {enquiry.organisation}
          </p>
        </div>

        <Link
          to="/admin/partnership-enquiries"
          className="admin-secondary-link"
        >
          ← Partnership Enquiries
        </Link>
      </header>

      {message && (
        <div className="ped-message success">
          {message}
        </div>
      )}

      {error && (
        <div className="ped-message error">
          {error}
        </div>
      )}

      <section className="ped-layout">
        <article className="ped-main">
          <div className="ped-meta-grid">
            <div>
              <span>
                Name
              </span>

              <strong>
                {enquiry.name}
              </strong>
            </div>

            <div>
              <span>
                Organisation
              </span>

              <strong>
                {enquiry.organisation}
              </strong>
            </div>

            <div>
              <span>
                Email
              </span>

              <a
                href={
                  `mailto:${enquiry.email}`
                }
              >
                {enquiry.email}
              </a>
            </div>

            <div>
              <span>
                Country
              </span>

              <strong>
                {enquiry.country ||
                 '—'}
              </strong>
            </div>

            <div>
              <span>
                Partnership area
              </span>

              <strong>
                {
                  enquiry.partnership_area
                }
              </strong>
            </div>

            <div>
              <span>
                Submitted
              </span>

              <strong>
                {new Intl.DateTimeFormat(
                  'en',
                  {
                    day: 'numeric',
                    month: 'long',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                  }
                ).format(
                  new Date(
                    enquiry.created_at
                  )
                )}
              </strong>
            </div>
          </div>

          <div className="ped-message-body">
            <p className="ped-label">
              Message
            </p>

            <p>
              {enquiry.message}
            </p>
          </div>

          <div className="ped-reply">
            <a
              href={
                `mailto:${enquiry.email}` +
                `?subject=${encodeURIComponent(
                  `Re: ${enquiry.subject}`
                )}`
              }
            >
              Reply by email
            </a>
          </div>
        </article>

        <aside className="ped-sidebar">
          <p className="ped-label">
            Workflow status
          </p>

          <select
            value={enquiry.status}
            onChange={(event) =>
              updateStatus(
                event.target.value
              )
            }
          >
            {STATUSES.map(
              ([value, label]) => (
                <option
                  key={value}
                  value={value}
                >
                  {label}
                </option>
              )
            )}
          </select>

          <div className="ped-current-status">
            Current status

            <strong>
              {enquiry.status}
            </strong>
          </div>
        </aside>
      </section>
    </main>
  );
};

export default PartnershipEnquiryDetailPage;
